// eslint-disable-next-line import/prefer-default-export
export enum Truncate {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
}
